import { UnstyledButton, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';

export const ThemeToggle = () => {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const activeColor = 'var(--color-text-on-accent)';
  const inactiveColor = 'var(--color-icon-on-secondary-soft)';

  return (
    <UnstyledButton
      onClick={toggleColorScheme}
      w={40}
      h={20}
      style={{
        position: 'relative',
        borderRadius: 999,
        backgroundColor: 'var(--color-overlay-icon-surface)',
        flexShrink: 0
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 2,
          left: isDark ? 22 : 2,
          width: 16,
          height: 16,
          borderRadius: 999,
          backgroundColor: '#d2a94c',
          transition: 'left 150ms ease'
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: 4.5,
          left: 4.5,
          width: 11,
          height: 11,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <IconSun size={11} color={isDark ? inactiveColor : activeColor} />
      </div>
      <div
        style={{
          position: 'absolute',
          top: 4.5,
          left: 24,
          width: 11,
          height: 11,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <IconMoon size={11} color={isDark ? activeColor : inactiveColor} />
      </div>
    </UnstyledButton>
  );
};
